import Box from "../assets/box.png";
import Bjj from "../assets/bjj.png";

export const programsData = [
  {
    image: (
      <svg
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        fill="#ffffff"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>sports-mma</title>{" "}
          <g id="Layer_2" data-name="Layer 2">
            {" "}
            <g id="invisible_box" data-name="invisible box">
              {" "}
              <rect width="48" height="48" fill="none"></rect>{" "}
            </g>{" "}
            <g id="Q3_icons" data-name="Q3 icons">
              {" "}
              <path d="M32.1,2H15.9L2,12.5v23L15.9,46H32.1L46,35.5v-23ZM18,6H30V18H18ZM6,22.5,8,24,6,25.5ZM14,29V39.6L6,33.5v-3l5.3-4L14,28.6Zm-2.7-7.5L6,17.5v-3l8-6.1v11ZM30,42H18V30H30Zm.8-16H17.2l-2.6-2,2.6-2H30.8l2.6,2ZM42,33.5l-8,6.1v-11l2.7-2.1,5.3,4Zm0-8L40,24l2-1.5ZM42,15v2.5l-5.3,4L34,19.4V8.4l8,6.1Z"></path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
    ),
    heading: "MMA",
    details:
      "Trenirajte Mixed Martial Arts sa sveobuhvatnim programom prilagođenim za sve nivoe, od početnika do naprednih boraca.",
  },
  {
    image: <img src={Bjj} alt="" />,
    heading: "BJJ",
    details:
      "Zaronite u umetnost Brazilske Jiu-Jitse sa vrhunskim instruktorima. Naučite tehnike borbe u parteru, u okruženju punom podrške.",
  },
  {
    image: <img src={Box} alt="" />,
    heading: "Kickbox",
    details:
      " Izoštrite svoje veštine udaranja sa našim specijalizovanim časovima kickboxa. Idealno za fitnes, samoodbranu i takmičarski trening.",
  },
  // {
  //   image: (
  //     <svg
  //       width="20"
  //       height="16"
  //       viewBox="0 0 20 16"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path d="M19 6.31132H16.5C16.3677 6.31187 16.2368 6.33867 16.1149 6.39017C15.9931 6.44166 15.8826 6.51683 15.79 6.61132L14.55 7.90132L11.75 4.71132C11.6565 4.61141 11.5434 4.53177 11.4179 4.47732C11.2923 4.42287 11.1569 4.39477 11.02 4.39477C10.8831 4.39477 10.7477 4.42287 10.6222 4.47732C10.4966 4.53177 10.3836 4.61141 10.29 4.71132L8.59001 6.41132H7.00001C6.7348 6.41132 6.48044 6.51668 6.2929 6.70422C6.10537 6.89175 6.00001 7.14611 6.00001 7.41132C6.00001 7.67654 6.10537 7.93089 6.2929 8.11843C6.48044 8.30597 6.7348 8.41132 7.00001 8.41132H9.00001C9.13162 8.41208 9.26208 8.38686 9.38392 8.33709C9.50576 8.28733 9.61657 8.214 9.71001 8.12132L11 6.78132L13.8 9.97132C13.8903 10.0743 14.0009 10.1576 14.1247 10.2161C14.2486 10.2746 14.3831 10.307 14.52 10.3113C14.6516 10.3121 14.7821 10.2869 14.9039 10.2371C15.0258 10.1873 15.1366 10.114 15.23 10.0213L16.93 8.31132H19C19.2652 8.31132 19.5196 8.20597 19.7071 8.01843C19.8947 7.83089 20 7.57654 20 7.31132C20 7.04611 19.8947 6.79175 19.7071 6.60422C19.5196 6.41668 19.2652 6.31132 19 6.31132ZM11.61 11.6113L9.71001 13.5113C9.61705 13.6051 9.50645 13.6794 9.38459 13.7302C9.26273 13.781 9.13202 13.8071 9.00001 13.8071C8.868 13.8071 8.73729 13.781 8.61543 13.7302C8.49358 13.6794 8.38297 13.6051 8.29001 13.5113L3.08001 8.30132C2.73713 7.95865 2.46513 7.55177 2.27955 7.10393C2.09398 6.6561 1.99846 6.17608 1.99846 5.69132C1.99846 5.20656 2.09398 4.72655 2.27955 4.27871C2.46513 3.83088 2.73713 3.424 3.08001 3.08132C3.77167 2.39189 4.70843 2.00476 5.68501 2.00476C6.66159 2.00476 7.59835 2.39189 8.29001 3.08132C8.38297 3.17505 8.49358 3.24945 8.61543 3.30021C8.73729 3.35098 8.868 3.37712 9.00001 3.37712C9.13202 3.37712 9.26273 3.35098 9.38459 3.30021C9.50645 3.24945 9.61705 3.17505 9.71001 3.08132C10.4127 2.41304 11.3453 2.04037 12.315 2.04037C13.2847 2.04037 14.2173 2.41304 14.92 3.08132C15.1428 3.30707 15.3376 3.55889 15.5 3.83132C15.6456 4.03154 15.8603 4.17062 16.1026 4.22167C16.3448 4.27272 16.5974 4.2321 16.8114 4.10767C17.0254 3.98324 17.1856 3.78385 17.2611 3.54808C17.3366 3.3123 17.322 3.05691 17.22 2.83132C16.9728 2.42087 16.6774 2.0415 16.34 1.70132C15.391 0.741174 14.1311 0.150426 12.786 0.0349788C11.4409 -0.0804685 10.0988 0.286933 9.00001 1.07132C8.15087 0.459617 7.14924 0.0943988 6.10565 0.0159735C5.06206 -0.0624518 4.0171 0.148965 3.08607 0.626892C2.15504 1.10482 1.37416 1.83067 0.829583 2.72435C0.28501 3.61804 -0.00207453 4.6448 1.12854e-05 5.69132C-0.000288296 6.43541 0.147178 7.17216 0.433854 7.85881C0.72053 8.54546 1.14071 9.16834 1.67001 9.69132L6.88001 14.9013C7.44251 15.4631 8.20501 15.7787 9.00001 15.7787C9.79501 15.7787 10.5575 15.4631 11.12 14.9013L13 13.0213C13.1863 12.834 13.2908 12.5805 13.2908 12.3163C13.2908 12.0521 13.1863 11.7987 13 11.6113C12.8135 11.4311 12.5644 11.3303 12.305 11.3303C12.0457 11.3303 11.7965 11.4311 11.61 11.6113Z" />
  //     </svg>
  //   ),
  //   heading: "Health Fitness",
  //   details:
  //     "This programs is designed for those who exercises only for their body fitness not body building.",
  // },
];
